<template>
  <div class="product-photos">
    <div class="product-photos__control">
      <label>{{ getMessageByLang('addFileTitle', 'addFileTitle') }}</label>
      <div class="wrap-upload">
        <Upload v-if="photosList.length < maxCountPhotos" @add="onAddFile" @remove="onRemoveFile"
                ref="RefFileUpload"/>

        <UploaderHints @click="triggerFileUpload"/>
      </div>

      <p v-if="notificationText" class="product-photos__noti">
        {{ notificationText }}
      </p>
    </div>

    <ul class="product-photos__list dome-lk-list">
      <li v-for="(photo, indexPhoto) in photosList" :key="photo" class="product-photos__card-photo">
        <CardPhoto :img="photo.img" :file="photo" :isGenerate="true" @remove="handleRemove"
                   :index="indexPhoto"/>
      </li>
    </ul>
  </div>
</template>

<script>
import {validPhotoExtentions} from '@/constants/File.js';
import {getMessageByLang} from '@/utils/translate.js';

import {Upload} from '@progress/kendo-vue-upload';

import CardPhoto from '@/components/photos/CardPhoto';
import UploaderHints from '@/components/uploader/UploaderHints.vue';

const defaultMaxCountPhotos = 10;

export default {
  components: {
    Upload,
    CardPhoto,
    UploaderHints
  },

  data: function () {
    return {
      photosList: [],
      photoListRemove: [],
      getMessageByLang: getMessageByLang,
    }
  },
  props: {
    photos: {
      type: Array,
      required: false,
      default: () => {
      }
    },
    maxCountPhotos: {
      type: Number,
      required: false,
      default: defaultMaxCountPhotos
    },
    notificationText: {
      type: String,
      required: false,
      default: null
    }
  },
  inject: {
    kendoLocalizationService: {default: null},
  },
  methods: {
    triggerFileUpload() {
      console.log('trigger');
      console.log('this.$refs.uploadRef', this.$refs);
      try {
        if (this.$refs.RefFileUpload) {
          const uploadButton = this.$refs.RefFileUpload.$el?.querySelector('.k-upload-button');
          if (uploadButton) {
            uploadButton.click();
          }
        }

      } catch (err) {
        console.error(err);
      }
    },

    onAddFile(file) {
      if (file?.affectedFiles) {
        const activeFile = file.affectedFiles[0];

        if (validPhotoExtentions.includes(activeFile.extension)) {
          this.photosList.push({
            ...activeFile,
            img: `${activeFile.uid}`,
            isNew: true
          })
        } else {
          alert(this.getMessageByLang('selectAnotherFile', 'Выберите другой формат файла'));
        }
      }
    },
    handleRemove(options = null) {
      if (options) {
        this.photosList.splice(options.index, 1);
        this.photoListRemove.push(options.photo.id);
      }
    },
    getPhotos() {
      const arr = [];

      for (let photo of this.photosList) {
        if (photo.isNew) {
          const file = photo.getRawFile ? photo.getRawFile() : photo.rawFile || photo.file;
          arr.push(file);
        }
      }

      return arr;
    },

    getPhotosRemove() {
      return this.photoListRemove;
    }
  },
  mounted() {
    this.photosList = this.photos || [];
  }
}
</script>


<style lang="scss">
.product-photos {
  &__list {
    display: flex;
    gap: 1rem;
  }

  &__control {
    & .k-dropzone-hint {
      display: none;
    }
  }

  &__noti {
    margin: 0;
    color: #999;
    font-size: 12px;
  }
}

.product-photos__card-photo {
  height: 128px;
  width: 128px;

  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>